    export default function PopupLabelAndValue(props: {label: string, 
        value?: any,
        className? : string}) : JSX.Element {
    return <>
        <div className={"text-primary font-semibold text-sm "+
                props.className}>
            {props.label}
            <div className="font-normal text-sm text-navy_blue">{props.value}</div>
        </div>
    </>
}